<h1 class="title-modal-add-user" mat-dialog-title>
  <strong>Import File Xlsx</strong>
  <mat-icon (click)="onClose()">close</mat-icon>
</h1>
<mat-divider class="divider"></mat-divider>
<mat-horizontal-stepper linear="true" color="accent">
  <mat-step [stepControl]="step1" [color]="selected ? 'accent' : 'primary'">
    <form [formGroup]="step1">
      <ng-template matStepLabel>STEP 1</ng-template>
      <mat-form-field fxFill appearance="fill">
        <mat-label>File Name</mat-label>
        <input matInput formControlName="value" placeholder="File name" required text />
      </mat-form-field>
      <div>
        <button mat-flat-button color="accent" matStepperNext [disabled]="step1.invalid">Next</button>
      </div>
    </form>
  </mat-step>
  <mat-step [color]="selected ? 'accent' : 'primary'">
    <ng-template matStepLabel>STEP 2</ng-template>
    <mat-tab-group dynamicHeight animationDuration="500ms" class="toto" color="accent">
      <mat-tab label="Sheet 0">
        <mic-app-formulaire></mic-app-formulaire>
      </mat-tab>
      @for (item of sheets; track $index) {
      <mat-tab [label]="'Sheet ' + (sheets.lastIndexOf(item) + 1)">
        <mic-app-formulaire></mic-app-formulaire>
      </mat-tab>
      }
    </mat-tab-group>
    <div class="button-container">
      <div>
        <button (click)="onSubmit()" mat-flat-button matStepperNext color="accent" [disabled]="">Submit</button>
      </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>
